package org.hs_soft.runmynesto.data.api_datasource.options.operation

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.operation.option_model.OptionDataModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.operation.UpdateOptionRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class UpdateOptionRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): UpdateOptionRepository {
    override suspend fun updateOption(
        dataValue: dynamic,
        dataTitle: String
    ): OptionDataModel {

        val abortController = requestManager.createController()


        val graphQLQuery = buildJsonObject {
            put("query", """
                mutation updateAppConfig(${'$'}fields: AppConfigInput!) {
                  cashAssist {
                    updateAppConfig(fields:${'$'}fields) {
                      ...generalSettings
                      __typename
                    }
                    __typename
                  }
                }

                fragment generalSettings on AppConfig {
                  ${ApiUtils.Field.name}
                  ${ApiUtils.Field.street}
                  ${ApiUtils.Field.postCode}
                  ${ApiUtils.Field.city}
                  ${ApiUtils.Field.countryId}
                  ${ApiUtils.Field.language}
                  ${ApiUtils.Field.mainCurrency}
                  ${ApiUtils.Field.isShopFieldActive}
                  cashRegisterGlobal {
                    ${ApiUtils.Field.portosIntegrationKey}
                    ${ApiUtils.Field.e2nReportingActive}
                    ${ApiUtils.Field.e2nIntegrationActive}
                    ${ApiUtils.Field.isRevolutPaymentActive}
                    ${ApiUtils.Field.revolutPaymentDiscount}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.__typename}
                }

            """.trimIndent())



            putJsonObject("variables") {
                putJsonObject("fields") {
                    when(dataValue){
                        is Boolean ->put(dataTitle, dataValue as Boolean)
                        is String ->put(dataTitle,dataValue as String)
                    }
                }
            }

        }

        val result=apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
           abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)

        }

    }

}
